import { Box, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import * as yup from "yup";
import FormikDatePicker from "../../../commons/formik/formikDatePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import { StyledSearchContainer } from "../../../styled/connectivity";
import { StyledForm } from "../../../styled/form";
import { StyledPaper } from "../../../styled/paper";

const validationSchema = yup.object().shape({
  art: yup.string().required("La ART es obligatoria"),
  fechaDesde: yup
    .date()
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaDesde",
      message: "La fecha desde debe ser menor o igual a la fecha hasta",
      test: function (value) {
        if (this.parent.fechaHasta && value <= this.parent.fechaHasta) {
          return true;
        }
        return false;
      },
    })
    .required("La fecha desde es obligatoria"),

  fechaHasta: yup
    .date()
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaHasta",
      message: "La fecha hasta debe ser mayor o igual a la fecha desde",
      test: function (value) {
        if (this.parent.fechaDesde && value >= this.parent.fechaDesde) {
          return true;
        }
        return false;
      },
    })
    .required("La hasta desde es obligatoria"),
});

const Search = ({ handleSubmit, loading, initialValues }) => {
  const arts = useSelector((state) => state.art.artsAdhered);

  return (
    <div>
      <StyledPaper.Container>
        <FormikForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}>
          {({ errors }) => (
            <>

              <StyledSearchContainer.Form>
                <Box
                  sx={{
                    width: "90%",
                    display: "flex",
                  }}>
                  <StyledForm.Input>
                    <FormikSelect
                      name="art"
                      label="Art"
                      variant="standard"
                      value={initialValues.art}>
                      {arts.map((art) => {
                        return (
                          <MenuItem value={art.id} key={art.id}>
                            {art.nombre}
                          </MenuItem>
                        );
                      })}
                    </FormikSelect>
                  </StyledForm.Input>
                  <StyledForm.Input>
                    <FormikTextField
                      name="siniestro"
                      variant="standard"
                      label="Siniestro"
                    />
                  </StyledForm.Input>

                  <StyledForm.Input>
                    <FormikTextField
                      name="dni"
                      variant="standard"
                      label="DNI"
                    />
                  </StyledForm.Input>

                  <StyledForm.Input>
                    <FormikDatePicker
                      name="fechaDesde"
                      variant="standard"
                      disabledButtons
                      label="Fecha Desde"
                    />
                  </StyledForm.Input>

                  <StyledForm.Input>
                    <FormikDatePicker
                      fullWidth
                      name="fechaHasta"
                      variant="standard"
                      label="Fecha Hasta"
                    />
                  </StyledForm.Input>
                </Box>
                <StyledForm.ButtonContainer>
                  <StyledForm.Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={loading}>
                    Buscar
                  </StyledForm.Button>
                </StyledForm.ButtonContainer>
              </StyledSearchContainer.Form>
            </>
          )}
        </FormikForm>
      </StyledPaper.Container>
    </div>
  );
};

export default Search;
